import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

// Limpiar cualquier service worker viejo (solo una vez)
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(registration => {
      registration.unregister();
      console.log('🧹 Service Worker eliminado:', registration.scope);
    });
  });
}

// En desarrollo, forzar recarga si hay problemas de caché
if (import.meta.env.DEV) {
  // Agregar timestamp a la URL para evitar caché
  const currentUrl = new URL(window.location.href);
  if (!currentUrl.searchParams.has('_t')) {
    currentUrl.searchParams.set('_t', Date.now());
    window.history.replaceState({}, '', currentUrl);
  }

  // Log para debug
  console.log('🚀 App iniciada en modo desarrollo - Sin caché');
}

// En desarrollo, StrictMode está deshabilitado para evitar renders duplicados innecesarios
// Solo habilitar cuando se necesite depurar efectos secundarios
const isDevelopment = import.meta.env.DEV;
const enableStrictMode = false; // Cambiar a true solo para depuración profunda

const app = enableStrictMode && isDevelopment ? (
  <StrictMode>
    <App />
  </StrictMode>
) : (
  <App />
);

createRoot(document.getElementById('root')).render(app);
